import { EntityListSourceTypeSummary, EntityListTypeSupported } from '../../entityListsLib';
import { useSelector } from 'react-redux';
import { ReduxState, useAppDispatch } from '../../../../../store';
import { Checkbox } from 'antd';
import React, { useCallback, useMemo } from 'react';
import { EntityListSourceType } from '@ydistri/api-sdk';
import { setSourceTypeFilters } from '../../entityListAdministrationSlice';
import { Label, Row } from '@ydistri/ds';

interface EntityListSourceTypeFilterProps {
  entityListType: EntityListTypeSupported;
  entityListSourceTypeSummary: EntityListSourceTypeSummary;
}

/**
 * Displays a set of checkboxes to filter entity lists by their source type
 * When a checkbox is checked, the redux store is updated
 * @param entityListType
 * @param entityListSourceTypeSummary number of entity lists per source type
 * @constructor
 */
const EntityListSourceTypeFilter: React.FC<EntityListSourceTypeFilterProps> = ({
  entityListType,
  entityListSourceTypeSummary,
}) => {
  const dispatch = useAppDispatch();

  const sourceTypeFilters = useSelector(
    (state: ReduxState) => state.entityListsAdministration[entityListType].sourceTypeFilters,
  );

  const filterOptions = useMemo(() => {
    return [
      {
        label: `User (${entityListSourceTypeSummary[EntityListSourceType.User]})`,
        value: EntityListSourceType.User,
      },
      {
        label: `Integration (${entityListSourceTypeSummary[EntityListSourceType.Integration]})`,
        value: EntityListSourceType.Integration,
      },
      {
        label: `Computed (${entityListSourceTypeSummary[EntityListSourceType.Computation]})`,
        value: EntityListSourceType.Computation,
      },
    ];
  }, [entityListSourceTypeSummary]);

  const onFiltersChange = useCallback(
    (checkedValues: EntityListSourceType[]) => {
      dispatch(setSourceTypeFilters({ entityListType, data: checkedValues }));
    },
    [dispatch, entityListType],
  );

  return (
    <Row $gap="1rem">
      <Label>List types:</Label>
      <Checkbox.Group
        options={filterOptions}
        value={sourceTypeFilters}
        onChange={onFiltersChange}
      />
    </Row>
  );
};

export default EntityListSourceTypeFilter;
